const axios = require('axios');
const BASE_URL = "https://gx18.admintour.com/motor/API_Motor_Admintour";
const BOOK_URL = "https://gx18.admintour.com/motor/API_MotorReserva"
const ADMINTOUR_BASEURL = "https://gx18.admintour.com/admintour/API_ChannelAdmintour";
const LOSHEROES_BASEURL = "https://ext-qa-gcp-api-recreactiva.cclh.io/qa/apilh/v2/lhcliente";

async function obtenerList() {
    try {
        const response = await axios.get(`${BASE_URL}/List`);
        return response.data;
    } catch (error) {
        console.error('Error fetching list data:', error);
        throw new Error('Error fetching list data');
    }
}

async function obtenerImagenCabezal(hotcod) {
    try {
        const response = await axios.get(`${BASE_URL}/Cabezal?hotcod=${hotcod}`);
        return response.data.archivofoto;
    } catch (error) {
        console.error('Error fetching header image:', error);
        throw new Error('Error fetching header image');
    }
}

async function obtenerMuestroCarrito(codigo, sesion) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_Carrito?hotcod=${codigo}&Sesion=${sesion}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.Carrito;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        throw new Error('Error fetching cart data');
    }
}

async function obtenerDetalleCarrito(codigo, sesion, lineahabitacion) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_Detalle_Carrito?hotcod=${codigo}&Sesion=${sesion}&lineahabitacion=${lineahabitacion}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.Carrito;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        throw new Error('Error fetching cart data');
    }
}

async function grabarCarrito(carrito) {
    try {
        const response = await axios.post(`${BASE_URL}/Creo_Carrito_Hab`, carrito);
        return response.data;
    } catch (error) {
        console.error('Error creating cart:', error);
        throw new Error('Error creating cart');
    }
}

async function eliminarItemCarrito(BorrarHotel, BorrarSesion, BorrarLinea) {
    try {
        const response = await axios.post(`${BASE_URL}/Borro_Linea_Hab`, {
            BorrarHotel,
            BorrarSesion,
            BorrarLinea
        });
        return response.data.Carrito;
    } catch (error) {
        console.error('Error al eliminar el ítem del carrito:', error);
        throw new Error('Error al eliminar el ítem del carrito');
    }
}

async function confirmarReserva(hotelcarrito, Sesion, reservanombre, motorreservanombretitular,motorreservaapellidotitular, reservatelefono, reservacorreo, reservadireccion, motorreservatelefono, reservapais, reservatipodocumento, reservadocumento, reservafechanacimiento, reservaautocolor, reservaautomarca, reservaautomatricula, reservaobservaciones) {
    try {
        const response = await axios.post(`${BASE_URL}/Creo_Reserva`, {
            hotelcarrito,
            Sesion,
            reservanombre,
            motorreservanombretitular,
            motorreservaapellidotitular,
            reservatelefono,
            reservacorreo,
            reservadireccion,
            motorreservatelefono,
            reservapais,
            reservatipodocumento,
            reservadocumento,
            reservafechanacimiento,
            reservaautocolor,
            reservaautomarca,
            reservaautomatricula,
            reservaobservaciones
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        throw new Error('Error fetching cart data');
    }
}

async function obtenerDispoCalendario(hotcod, desdeFecha, hastaFecha) {
    try {
        const response = await axios.get(`${BASE_URL}/Dispo_Calendario?hotcod=${hotcod}&DesdeFecha=${desdeFecha}&hastafecha=${hastaFecha}`);
        return response.data.Calendario;
    } catch (error) {
        console.error('Error fetching availability data:', error);
        throw new Error('Error fetching availability data');
    }
}

async function obtenerMuestroTarifaTipoHab(hotel, tipoHab, fecha) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_Tarifa_TipoHab?HotCod=${hotel}&TipoHab=${tipoHab}&FechaTarifa=${fecha}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.TarifaTipoHabItem;
    } catch (error) {
        console.error('Error fetching tariff data:', error);
        throw new Error('Error fetching tariff data');
    }
}

async function obtenerMuestroTiposHabitacion(hotcod, desdeFecha, hastaFecha) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_TiposHabitacion?hotcod=${hotcod}&DesdeFecha=${desdeFecha}&hastafecha=${hastaFecha}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.TiposHabitacion;
    } catch (error) {
        console.error('Error fetching room types data:', error);
        throw new Error('Error fetching room types data');
    }
}

async function obtenerServiciosDeHabitacion(hotcod, tipoHab) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_Servicios_TipoHab?hotcod=${hotcod}&TipoHab=${tipoHab}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.ServicioTipoHab;
    } catch (error) {
        console.error('Error fetching services data:', error);
        throw new Error('Error fetching services data');
    }
}

async function obtenerFotosTipoHab(hotcod, TipoHab) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_FotosTipoHab?hotcod=${hotcod}&TipoHab=${TipoHab}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data.TiposHabFotos;
    } catch (error) {
        console.error('Error fetching photos data:', error);
        throw new Error('Error fetching photos data');
    }
}

async function obtenerDatosHotel(hotcod) {
    try {
        const response = await axios.get(`${BASE_URL}/Muestro_DatosHotel?hotcod=${hotcod}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching photos data:', error);
        throw new Error('Error fetching photos data');
    }
}

async function graboReservaEnAdmintour(hotcod, reservamotor, sdt_motorreserva) {
    try {
        const response = await axios.post(`${ADMINTOUR_BASEURL}/GraboReservaMotor`, { hotcod, sdt_motorreserva, reservamotor });
        return response.data;
    } catch (error) {
        console.error('Error grabando reserva admintour:', error);
        throw new Error('Error grabando reserva admintour:');
    }
}
async function holaMundoAdmintour() {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/holamundo`);
        return response;
    } catch (error) {
        console.error('ERROR HOLA MUNDO:', error);
        throw new Error('ERROR HOLA MUNDO');
    }
}

async function obtenerPaises(hotcod) {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/Pais?hotcod=${hotcod}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener paises', error);
        throw new Error('Error al obtener paises');
    }
}

async function obtenerDocumentos(hotcod) {
    try {
        const response = await axios.get(`${ADMINTOUR_BASEURL}/TipoDeDocumento?hotcod=${hotcod}`, {
            headers: { 'Cache-Control': 'no-cache' }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener documentos', error);
        throw new Error('Error al obtener documentos');
    }
}

async function obtenerReservasMotor(hotcod, motorReservaId) {
    try {
        const response = await axios.get(
            `${BOOK_URL}/Leer?MotorHotCod=${hotcod}&MotorReservaId=${motorReservaId}`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching list data:", error);
        throw new Error("Error fetching list data");
    }
}

async function rutLosHeroes(rut) {
    try {
        const response = await axios.get(`${LOSHEROES_BASEURL}/?rut=${rut}`, {
            headers: {
                'user-key': '0a1a018f7921ed9ead936e0b1608bfb2', 
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching rut data:", error);
        throw new Error("Error fetching rut data");
    }
}
module.exports = {
    obtenerList,
    obtenerImagenCabezal,
    obtenerDispoCalendario,
    obtenerMuestroTarifaTipoHab,
    obtenerMuestroTiposHabitacion,
    obtenerServiciosDeHabitacion,
    grabarCarrito,
    obtenerMuestroCarrito,
    eliminarItemCarrito,
    confirmarReserva,
    obtenerDetalleCarrito,
    obtenerFotosTipoHab,
    obtenerDatosHotel,
    graboReservaEnAdmintour,
    holaMundoAdmintour,
    obtenerReservasMotor,
    obtenerPaises,
    obtenerDocumentos,
    rutLosHeroes
};
